export default __webpack_public_path__ + "static/media/PickupBoxIcon.3f8a194a.svg";